import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import store from '../../redux/store';
import { AnalyticsProvider } from './AnalyticsProvider';
import { AuthProvider } from './AuthProvider';
import { ChatProvider } from './ChatProvider';
import DrawerProvider from './DrawerProvider';
import { ErrorProvider } from './ErrorProvider';
import { FeatureProvider } from './FeatureProvider';
import { NavBarRoutesProvider } from './NavbarRoutesProvider';
import NotificationsProvider from './NotificationsProvider';
import { ProjectsProvider } from './ProjectsProvider';

interface Props {
  children: ReactNode;
}

const Providers: React.FC<Props> = ({ children }) => {
  return (
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider>
          <AnalyticsProvider>
            <NotificationsProvider>
              <ErrorProvider>
                <Provider store={store}>
                  <FeatureProvider>
                    <ChatProvider>
                      <DrawerProvider>
                        <ProjectsProvider>
                          <NavBarRoutesProvider>{children}</NavBarRoutesProvider>
                        </ProjectsProvider>
                      </DrawerProvider>
                    </ChatProvider>
                  </FeatureProvider>
                </Provider>
              </ErrorProvider>
            </NotificationsProvider>
          </AnalyticsProvider>
        </AuthProvider>
      </LocalizationProvider>
    </BrowserRouter>
  );
};

export default Providers;
